var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('common.total'))+" : ")]),_c('span',[_vm._v(_vm._s(_vm.totalCount))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"me-1"},[_c('i',{staticClass:"mdi mdi-circle-medium"})])
}]

export { render, staticRenderFns }